import { FC, useEffect, useRef } from 'react'
import { useAuthContext } from '@enuygun/frontend-components'
import GoogleOneTap from './index'
import { useDeviceType } from '../../hooks/useDeviceType'
import sendTrackerLog from '../../utils/tracker'
import { getAnalyticsRequestId } from '../../utils/analyticsRequestId'

interface GoogleOneTapWrapperProps {
  market: string
  domain: string
  endpoint: string
  host: string
  isTablet?: boolean
}

// Google One Tap Wrapper - Login kontrolü için
const GoogleOneTapWrapper: FC<GoogleOneTapWrapperProps> = ({ market, domain, endpoint, host, isTablet }) => {
  const authContext = useAuthContext()
  const { isMobile, isTablet: isTabletDevice } = useDeviceType()
  const viewLoggedRef = useRef(false)
  const finalIsTablet = isTablet || isTabletDevice

  // Kullanıcı giriş yapmışsa Google One Tap gösterme
  // Token kontrolü en güvenilir yöntemdir - token varsa kullanıcı kesinlikle login olmuştur
  const hasToken = authContext?.token && authContext.token.trim().length > 0

  // User kontrolü - userId veya id varsa login olmuştur
  const user = authContext?.user
  const hasUserId = user && (('userId' in user && user.userId) || ('id' in user && user.id))

  // isAuthenticated kontrolü - eğer user varsa ve isAuthenticated true ise login olmuştur
  const isAuthenticated = user && 'isAuthenticated' in user && user.isAuthenticated === true

  // User objesi boş değilse ve içinde anlamlı property varsa login olmuştur
  const hasUserProperties = user && Object.keys(user).length > 0 && !(Object.keys(user).length === 1 && 'login_method' in user)

  const isLoggedIn = hasToken || hasUserId || isAuthenticated || hasUserProperties

  // GoogleOneTap view tracking - Component render edildiğinde ve kullanıcı login değilse
  useEffect(() => {
    if (isLoggedIn || authContext?.loading || viewLoggedRef.current) return

    // Google One Tap popup'ı genellikle script yüklendikten sonra görüntülenir
    // Script yüklendikten sonra bir süre bekleyip tracking yapalım
    const timeoutId = setTimeout(() => {
      if (viewLoggedRef.current || isLoggedIn || authContext?.loading) return

      viewLoggedRef.current = true
      const environment = isMobile || finalIsTablet ? 'MOBILE_WEB' : 'DESKTOP_WEB'
      const requestId = getAnalyticsRequestId()

      const isEnuygun = domain?.includes('enuygun') || market === 'tr'
      const basePath = isEnuygun ? '/uyelik' : '/account'
      const baseUrl = market === 'tr' ? host : endpoint
      const loginUri = `${baseUrl}${basePath}/member/hwi/google_one_tap`

      sendTrackerLog({
        category: isEnuygun ? 'enuygun-homepage' : 'wingie-homepage',
        page: isEnuygun ? 'enuygun-homepage' : 'wingie-homepage',
        type: 'view',
        message: 'google_one_tap_view',
        environment: environment,
        requestId,
        loginUri: loginUri || null,
        isMobile: !!(isMobile || finalIsTablet),
        market: market,
      })
    }, 1000) // Google script'inin yüklenmesi için bekle

    return () => {
      clearTimeout(timeoutId)
    }
  }, [isLoggedIn, authContext?.loading, isMobile, finalIsTablet, market, domain, endpoint, host])

  // Auth context henüz yükleniyorsa One Tap gösterme
  if (authContext?.loading) {
    return null
  }

  if (isLoggedIn) {
    return null
  }

  return <GoogleOneTap market={market} domain={domain} endpoint={endpoint} host={host} isTablet={isTablet} />
}

export default GoogleOneTapWrapper
